import { Typography } from 'antd';
import { InviteTypeEn } from 'src/constants/inviteType.enum';
const { Text } = Typography;
interface Props {
  inviteType: InviteTypeEn;
}

const InviteTag = ({ inviteType }: Props) => {
  switch (inviteType) {
    case InviteTypeEn.Guest:
      return <Text style={{ fontSize: 11 }}>Khách</Text>;
    case InviteTypeEn.Accepter:
      return <Text style={{ fontSize: 11 }}>Xác nhận</Text>;
    case InviteTypeEn.Approver:
      return <Text style={{ fontSize: 11 }}>Phê duyệt</Text>;
    case InviteTypeEn.Handler:
      return <Text style={{ fontSize: 11 }}>Xử lý</Text>;
    case InviteTypeEn.OwnerTicket:
      return (
        <Text
          style={{
            fontSize: 11,
            background: '#ffd700', // Gold
            color: '#8b4513', // Dark brown text
            padding: '2px 6px',
            borderRadius: '4px',
            fontWeight: 'bold'
          }}
        >
          Chủ phòng
        </Text>
      );
  }
};

export default InviteTag;
